<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication" style="page-break-before:always;"><em class="italic">Judge: What is your profession?<br/>Brodsky: Poet. Poet and translator.<br/>Judge: Who said you were a poet? Who assigned you that rank? <br/>Brodsky: No one. Who assigned me to the human race?<br/></em><span class="smallcaps">—</span>from the trial of the poet<span class="smallcaps"> <br/></span>J<span class="smallcaps">OSEPH </span>B<span class="smallcaps">RODSKY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Iregreteverything_00000.vue?82f7b3dc